import Settings from 'utils/Settings';

const MAPBOX_TOKENS = {
  DEV: 'pk.eyJ1IjoiYmlyZHN1cyIsImEiOiJjbHRmYzlzdWUwcG52MmtydzJsanl6ZDJ3In0.NxH-7A7w-HJb2rMqFnqICw',
  US: 'pk.eyJ1IjoiYmlyZHN1cyIsImEiOiJjbDJrcGRsb2EwNmJhM2lxaHQwbzAzM2tpIn0.EaIFeG7Vi4bFdE6CUgyzVA',
  GLOBAL:
    'pk.eyJ1IjoiYmlyZHNnbG9iYWwiLCJhIjoiY2wya3BqZnc5MDAweTNicWhjMmZ6MGU5MSJ9.GZVCTOrqQvB5I_O7FA_y6A',
};

const MAP_ZOOM_LEVELS = {
  COUNTRY: 3,
  REGION: 6,
  DETAIL: 12,
};

const MAPBOX_PADDING = {
  MOBILE: {
    top: 0,
    bottom: 300,
    left: 0,
    right: 0,
  },
  DESKTOP: {
    top: 0,
    bottom: 0,
    left: 370,
    right: 0,
  },
};

const FLY_TO_SPEED = 1200;

/**
 * Used to center the Store Locator map and to draw the initial bounding box
 */
const GEO_COORDS = {
  EU: {
    center: [14.2551, 49.526],
    southwest: [-22, 33],
    northeast: [55, 55],
  },
  UK: {
    center: [-3.435973, 55.378051],
    southwest: [-17.1543, 48.7213],
    northeast: [11.7175, 59.8678],
  },
  US: {
    center: [-95.712891, 37.09024],
    southwest: [-126, 18],
    northeast: [-68, 55],
  },
};

const GEO_COORDS_DEFAULT = GEO_COORDS[Settings.shopID] || GEO_COORDS.US;

const CAROUSEL_LAYOUT = {
  VERTICAL: 'ttb',
  HORIZONTAL: 'ltr',
};

const MAP_UI_PLACEMENTS = {
  CENTER: 'center',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
};

const STORE_LOCATOR_CARD_TYPES = {
  LIST: 'list',
  CARD: 'card',
};

const MAP_STYLE = 'mapbox://styles/mapbox/light-v11?optimize=true';

const CAROUSEL_OPTIONS = {
  type: 'slide',
  direction: 'ttb',
  height: '100%',
  autoHeight: true,
  pagination: false,
  lazyLoad: true,
  breakpoints: {
    [450]: {
      arrows: false,
      direction: 'ltr',
      padding: '14vw',
      gap: '8px',
      focus: 'center',
    },
    [600]: {
      arrows: false,
      direction: 'ltr',
      padding: '18vw',
      gap: '8px',
      focus: 'center',
    },
    [767]: {
      arrows: false,
      direction: 'ltr',
      padding: '25vw',
      gap: '8px',
      focus: 'center',
    },
  },
};

export {
  CAROUSEL_LAYOUT,
  CAROUSEL_OPTIONS,
  FLY_TO_SPEED,
  GEO_COORDS,
  GEO_COORDS_DEFAULT,
  MAPBOX_PADDING,
  MAPBOX_TOKENS,
  MAP_STYLE,
  MAP_UI_PLACEMENTS,
  MAP_ZOOM_LEVELS,
  STORE_LOCATOR_CARD_TYPES,
};
